<template>
  <div class="result">
    <div class="result__data">
      <form class="form">
        <div class="form__fieldset">

          <div class="form__container form__container--short">
            <label for="name_es" class="form__label">Nombre Español</label>
            <input type="text" name="name_es" id="name_es" v-model="entry.name_es" class="form__input" />
          </div>

          <div class="form__container form__container--short">
            <label for="name_en" class="form__label">Nombre Inglés</label>
            <input type="text" name="name_en" id="name_en" v-model="entry.name_en" class="form__input" />
          </div>

          <div class="form__container form__container--short">
            <label for="name_es" class="form__label">Color</label>
            <input type="color" name="color" id="color" v-model="entry.color" style="appearance:none;border:0;padding:0;border-radius:0;cursor:pointer"/>
          </div>

        </div>
      </form>
    </div>
    <div class="result__options">
      <button class="btn btn__default btn--small" @click.prevent="saveEntry" >Guardar</button>
      <button class="btn btn__caution btn--small" @click="deleteEntry">Borrar</button>
    </div>
    <confirmation v-if="confirm" @cancel="confirm = false"></confirmation>
  </div>
</template>


<script>
import confirmation from "@/components/layout/confirmation";
import httpService from "@/api/request";
export default {
  props: {
    entry: {
      type: Object,
      required: false,
      default() {
        return {
          id: null,
          name_es: null,
          name_en: null,
          color: null
        };
      }
    }
  },
  mixins: [httpService],
  components: {
    confirmation
  },
  data: function() {
    return {
      confirm: false
    };
  },
  mounted: function() {
    this.$on("continue", () => {
      this.confirm = false;
      this.proccedToDelete();
    });
  },
  methods: {
    deleteEntry: function() {
      if (this.entry.id) {
        this.confirm = true;
      } else {
        this.$emit("deleted");
      }
    },
    proccedToDelete: function() {
      let httpRequest = {
        module: "sectors"
      };
      this.delete(this.entry.id, httpRequest).then(() => {
        this.$store.commit("notificate", {
          title: "ENTRADA BORRADA",
          text: "La entrada ha sido borrada correctamente.",
          type: "success"
        });
        this.$emit("update");
      });
    },
    saveEntry: function() {
      let httpRequest = {
        params: "",
        element: this.entry,
        module: "sectors"
      };
      let action = null;
      if (this.entry.id) {
        action = this.put(this.entry.id, httpRequest);
      } else {
        action = this.post(httpRequest);
      }
      action
        .then(response => {
          this.$emit("update");
          console.log(response);
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/sectors/entry.vue